export default "/institutions/bnb.svg";